<template>
  <div class="container max-w-screen-xl">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Container',
};
</script>

<style scoped>
.container {
  margin: 0 auto;
}
</style>
